import { apiClient } from './client';
import type { ClassificationDef, ClassificationKind } from '../types';

export const classificationsApi = {
  /** All defs for the company; `kinds` narrows the request. Inactive included. */
  list: async (kinds?: ClassificationKind[]) => {
    const res = await apiClient.get('/classifications', {
      params: kinds?.length ? { kinds: kinds.join(',') } : undefined,
    });
    return res.data.data.classifications as ClassificationDef[];
  },

  create: async (data: {
    kind: ClassificationKind;
    label: string;
    color?: string;
    sortOrder?: number;
    isDefault?: boolean;
  }) => {
    const res = await apiClient.post('/classifications', data);
    return res.data.data.classification as ClassificationDef;
  },

  // `key` and `kind` are immutable — every filed ticket stores the key, and
  // some are written by the ingestion paths themselves.
  update: async (
    id: string,
    data: Partial<Pick<ClassificationDef, 'label' | 'color' | 'sortOrder' | 'isDefault' | 'isActive'>>,
  ) => {
    const res = await apiClient.put(`/classifications/${id}`, data);
    return res.data.data.classification as ClassificationDef;
  },

  delete: async (id: string) => {
    await apiClient.delete(`/classifications/${id}`);
  },
};
